import { StyleSheet, css } from 'aphrodite/no-important'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import FormLabel from '../FormLabel'

const classes = StyleSheet.create(styles)

export class FormField extends Component {
  constructor() {
    super()
    this.formFieldId = generateId()
  }
  getChildContext() {
    return {
      formFieldId: this.formFieldId,
    }
  }

  renderRequired = () => {
    if (this.props.required) {
      return <span style={styles.required}>*</span>
    }
  }

  render() {
    const { formLayout = 'basic', labelWidth } = this.context
    const {
      aphroditeStyles,
      children,
      className,
      cropLabel,
      htmlFor,
      label,
      offsetAbsentLabel,
      required,
      ...props
    } = this.props
    props.className = css(
      classes.FormField,
      classes['FormField--form-layout-' + formLayout],
      offsetAbsentLabel ? classes['FormField--offset-absent-label'] : null,
      aphroditeStyles
    )
    if (className) {
      props.className += ' ' + className
    }
    if (offsetAbsentLabel && labelWidth) {
      props.style = {
        paddingLeft: labelWidth,
        ...props.style,
      }
    }

    // elements
    const componentLabel = label ? (
      <FormLabel htmlFor={htmlFor} cropText={cropLabel} required={required}>
        {label} {this.renderRequired()}
      </FormLabel>
    ) : null

    return (
      <div {...props} htmlFor={htmlFor}>
        {componentLabel}
        {children}
      </div>
    )
  }
}

const stylesShape = {
  _definition: PropTypes.object,
  _name: PropTypes.string,
}

FormField.contextTypes = {
  formLayout: PropTypes.oneOf(['basic', 'horizontal', 'inline']),
  labelWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
FormField.childContextTypes = {
  formFieldId: PropTypes.string,
}
FormField.propTypes = {
  aphroditeStyles: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(stylesShape)),
    PropTypes.shape(stylesShape),
  ]),
  children: PropTypes.node,
  cropLabel: PropTypes.bool,
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  offsetAbsentLabel: PropTypes.bool,
}

function generateId() {
  return Math.random().toString(36).substr(2, 9)
}

export default FormField
